import apiClient from '@/Services/Clients/apiClient';
import AssociatedFileModel from '@/Models/associatedFileModel';

const ASSOCIATED_FILE_BASE_URL: string = 'api/associatedFile';
class AssociatedFileService {

  public static getAssociatedFileByRequestId = (requestId: string): Promise<AssociatedFileModel[]> => {

    const resourceUrl = `${ASSOCIATED_FILE_BASE_URL}/request/${requestId}`;

    return apiClient.get(resourceUrl)
      .then(result => {
        const associatedFiles = AssociatedFileService.createAssociatedFilesModels(result);
        return associatedFiles;
      });
  };

  public static downloadAssociatedFileById = (associatedFileId: string)=> {
    const url = `${ASSOCIATED_FILE_BASE_URL}/download/${associatedFileId}`;
    apiClient.downloadPostRequest(url, { associatedFileId: associatedFileId });
  };

  private static createAssociatedFilesModels(serverAssociatedFilesModels) {

    let serverAssociatedFileModel;
    const associatedFilesModels = [];

    for (let i = 0; i < serverAssociatedFilesModels.length; i++) {
      serverAssociatedFileModel = serverAssociatedFilesModels[i];
      associatedFilesModels.push(new AssociatedFileModel(serverAssociatedFileModel));
    }

    return associatedFilesModels;
  }
}

export default AssociatedFileService;
